import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PSelectItem } from '../../../../../shared/design-system/atoms/p-select/p-select-item.model';
import { Report } from '../../../../models/report.model';

@Component({
  selector: 'app-garage-form',
  templateUrl: './garage-form.component.html',
  styleUrls: ['./garage-form.component.scss'],
})
export class GarageFormComponent implements OnChanges {
  @Input() garage!: Report.Characteristics.Garage | undefined;
  @Input() constructionYear!: number;

  @Output() garageChanged = new EventEmitter<Report.Characteristics.Garage>();

  @Output() constructionYearChanged = new EventEmitter<number>();

  garageForm = new FormGroup({
    propertyType: new FormControl('Garage', { nonNullable: true }),
    constructionYear: new FormControl('', [
      Validators.min(1000),
      Validators.max(9999),
      Validators.pattern(/^\d{4}$/),
    ]),
    numberOfParkingSlots: new FormControl(''),
    floor: new FormControl(''),
  });

  garageTypeItem!: PSelectItem;

  garageTypeItems: PSelectItem[] = [
    { value: null, label: '' },
    {
      value: 'closed_box_collective_or_individual_garage',
      label: 'Box fermé dans un parking collectif ou garage individuel',
    },
    { value: 'open_air_parking_spot', label: 'Emplacement à ciel ouvert' },
    {
      value: 'covered_collective_parking',
      label: 'Parking couvert dans un parking collectif',
    },
    {
      value: 'garage_building_less_than_500_m2',
      label:
        'Bâtiment à usage de garage sur un terrain ne dépassant pas 500 m²',
    },
    {
      value: 'individual_two_wheeler_parking',
      label: 'Emplacement individuel pour 2 roues',
    },
  ];

  garageInternal!: Report.Characteristics.Garage;
  constructionYearinternal!: number;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['garage'] && changes['garage'].currentValue) {
      this.garageInternal = changes['garage'].currentValue;
    }

    if (
      changes['constructionYear'] &&
      changes['constructionYear'].currentValue
    ) {
      this.garageForm.controls.constructionYear.setValue(
        this.constructionYear.toString(),
      );
    }

    this.setFormValues();
  }

  onConstructionYearChanged(event: Event) {
    this.constructionYearinternal = parseInt(
      (event.target as HTMLInputElement).value,
    );

    this.constructionYearChanged.emit(this.constructionYearinternal);
  }

  onGarageTypeSelected({ value }: PSelectItem): void {
    this.garageInternal = {
      ...this.garageInternal,
      garageType: value ? value : null,
    };

    this.garageTypeItem = { value };

    this.garageChanged.emit(this.garageInternal);
  }

  onNumberOfParkingSlotsChanged(event: Event) {
    this.garageInternal = {
      ...this.garageInternal,
      numberOfParkingSlots: parseInt((event.target as HTMLInputElement).value),
    };

    this.garageChanged.emit(this.garageInternal);
  }

  onFloorChanged(event: Event) {
    this.garageInternal = {
      ...this.garageInternal,
      floor: (event.target as HTMLInputElement).value,
    };

    this.garageChanged.emit(this.garageInternal);
  }

  setFormValues(): void {
    this.garageForm.controls.constructionYear.setValue(
      this.constructionYearinternal
        ? this.constructionYearinternal.toString()
        : '',
    );

    this.garageForm.controls.numberOfParkingSlots.setValue(
      this.garageInternal?.numberOfParkingSlots?.toString() || '',
    );

    this.garageForm.controls.floor.setValue(this.garageInternal?.floor || '');

    this.garageTypeItem = this.garageInternal
      ? this.garageTypeItems.find(
          (item) => item.value === this.garageInternal.garageType,
        )!
      : this.garageTypeItems[0];

    if (!this.garageInternal.garageType) {
      this.garageInternal.garageType = this.garageTypeItems[0].value as string;
    }
  }
}
